export default __webpack_public_path__ + "static/media/logo.a673a4b9.jpeg";